import theme from "@theme";
import { css, Global } from "@emotion/react";

const selectBox = {
  height: "30px", // Adjust the height as needed
  fontSize: "12px",
  "& .MuiInputBase-root": {
    color: theme.colors.grayborderColor, // Change the inactive color
    "&:hover": {
      color: theme.colors.themeColor, // Change the active color on hover
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.colors.themeColor, // Change the border color
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.colors.themeColor, // Change the border color when focused
  },
};

const globalStyles = css`
  .MuiFormLabel-root.MuiInputLabel-root {
    top: -3px !important;
  }
`;

const SC = {
  selectBox,
  GlobalStyles: <Global styles={globalStyles} />,
};

export default SC;
